import { createContext } from 'react';
const context = createContext({
    input: {
        size: 'medium',
    },
    button: {
        size: 'medium',
    },
});
export const WixStyleReactDefaultsOverrideContext = context;
export const WixStyleReactDefaultsOverrideProvider = context.Provider;
export const WixStyleReactDefaultsOverrideConsumer = context.Consumer;
//# sourceMappingURL=WixStyleReactDefaultsOverrideProvider.js.map